import React from "react";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { getFilenameFromPath } from "../../../misc/functions";
import { FeatureNameTooltip, FeatureKmtNameTooltip, FeatureKmtNameDrawerTooltip, FeatureTypeTooltip, FeatureModelFileTooltip, FeatureThumbnailFileTooltip, FeaturePriceTooltip } from "./../../tooltips/FeatureTooltips";

class EditFeaturesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  populateDropDown = () => {
    let dropdownItems = [];

    let featureTypes = this.props.featureTypes;
    for (let i = 0, len = featureTypes.length; i < len; i++) {
      dropdownItems.push(
        <option key={i} value={featureTypes[i].feature_type_id}>
          {featureTypes[i].feature_type_name}
        </option>
      );
    }

    return dropdownItems;
  };

  render() {
    return (
      <Modal show={this.props.editFeature} onHide={this.props.toggleEditFeature}>
        <Modal.Header closeButton>
          <Modal.Title>Feature Aanpassen</Modal.Title>
        </Modal.Header>
        <Form method='POST' encType='multipart/form-data' onSubmit={this.props.submitEditFeature}>
          <Modal.Body>
            <Form.Group>
              <Form.Label>
                Feature Naam <FeatureNameTooltip />
              </Form.Label>
              <Form.Control type='text' placeholder='Feature Naam' name='feature_name' defaultValue={this.props.selectedFeature.feature_name} />
              <span className={this.props.formErrors["feature_name"] ? "form-error" : "form-error-hidden"}>{this.props.formErrors["feature_name"]}</span>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                KMT Naam <FeatureKmtNameTooltip />
              </Form.Label>
              <Form.Control type="text" placeholder="Feature kmt naam" name="feature_kmt_name" defaultValue={this.props.selectedFeature.feature_kmt_name}/>
              <span className={this.props.formErrors["feature_kmt_name"] ? "form-error" : "form-error-hidden"}>{this.props.formErrors["feature_kmt_name"]}</span>
            </Form.Group>
            <Form.Group>
              <Form.Label>KMT Naam Lade <FeatureKmtNameDrawerTooltip /></Form.Label>
              <Form.Control type="text" placeholder="Feature kmt naam lade" name="feature_kmt_name_drawer" defaultValue={this.props.selectedFeature.feature_kmt_name_drawer}/>
              <span className={this.props.formErrors["feature_kmt_name_drawer"] ? "form-error" : "form-error-hidden"}>{this.props.formErrors["feature_kmt_name_drawer"]}</span>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Type <FeatureTypeTooltip />
              </Form.Label>
              <Form.Control as='select' name='feature_type' defaultValue={this.props.selectedFeature.feature_type} className='custom-select'>
                {this.populateDropDown()}
              </Form.Control>
              <span className={this.props.formErrors["feature_type"] ? "form-error" : "form-error-hidden"}>{this.props.formErrors["feature_type"]}</span>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Model Uploaden <FeatureModelFileTooltip />
              </Form.Label>
              <Form.Control type='file' name='feature_model' accept='.gltf, .glb' />
              <span className={this.props.formErrors["feature_model"] ? "form-error" : "form-error-hidden"}>{this.props.formErrors["feature_model"]}</span>
              <br />
              <p>Huidige bestandsnaam: {getFilenameFromPath(this.props.selectedFeature.feature_model_path)} </p>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Thumbnail Uploaden <FeatureThumbnailFileTooltip />
              </Form.Label>
              <Form.Control type='file' name='feature_thumbnail' accept='.png, .jpg, .jpeg' />
              <span className={this.props.formErrors["feature_thumbnail"] ? "form-error" : "form-error-hidden"}>{this.props.formErrors["feature_thumbnail"]}</span>
              <br />
              <p>Huidige bestandsnaam: {getFilenameFromPath(this.props.selectedFeature.feature_thumbnail_path)} </p>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Prijs <FeaturePriceTooltip />
              </Form.Label>
              <Form.Control type='number' step='0.01' placeholder='Prijs' name='feature_price' defaultValue={this.props.selectedFeature.feature_price} />
              <span className={this.props.formErrors["feature_price"] ? "form-error" : "form-error-hidden"}>{this.props.formErrors["feature_price"]}</span>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            {this.props.formErrors["submitError"] ? <Alert variant='danger'>{this.props.formErrors["submitError"]}</Alert> : null}
            <Button variant='primary' type='submit'>
              Aanpassen
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default EditFeaturesModal;
